import ModalBox from './ModalBox'
import ModalBoxScrollContent from './ModalBoxScrollContent'

ModalBox.ScrollContent = ModalBoxScrollContent

export default ModalBox
